import { CSS as CheckBoxCSS } from '../../components/input/input.checkbox';
import { CSS as TagIconCSS } from '../tag.icon/tag.icon.style';

export const CSS = {
	container: 'c-TagCardCheckbox',
	hasSelections: 'c-TagCardCheckbox__has-selections',
};

export const Style = {
	[CSS.container]: {
		display: 'flex',
		alignItems: 'center',
		position: 'relative',
	},
	[`${CSS.container} .${CheckBoxCSS.container}`]: {
		display: 'none',
		width: 'inherit',
		height: 'inherit',
	},
	// Hides whichever icon is currently showing — the plain colored dot (`.c-TagIcon`) or the bare
	// asset-type icon (`.c-TagIcon--bare`) — so the checkbox below can take its place on hover.
	[`${CSS.container}:hover .${TagIconCSS.container}`]: {
		display: 'none',
	},
	[`${CSS.container}:hover .${TagIconCSS.bareContainer}`]: {
		display: 'none',
	},
	[`${CSS.container}:hover .${CheckBoxCSS.container}`]: {
		display: 'flex',
	},
	[`${CSS.container}.${CSS.hasSelections} .${CheckBoxCSS.container}`]: {
		display: 'flex',
	},
};
